import { TextField } from "@material-ui/core";
import { Button } from "components";
import { Formik, Form, ErrorMessage, Field } from "formik";
import { decimalMask } from "utils/inputMasks";
import { mapPurchaseType } from "utils/mapType";

import { ButtonsContent } from "../../style";
import { validationSchema } from "./validationsSchema";

export const SelectionPage = ({ handleSubmit, batchData, isLoading }) => {
  const validation = validationSchema();
  const purchaseType = mapPurchaseType(batchData.product.purchase_type);

  const initialValues = {
    goodQuantity: undefined,
    diverseQuantity: undefined,
    wasteQuantity: undefined,
    wrongWeightQuantity: undefined
  };

  const handleFieldChange = (fieldName, setFieldValue) => e => {
    const maskedValue = decimalMask(e.target.value);

    // Atualiza o campo com o valor mascarado
    e.target.value = maskedValue;

    // Atualiza o Formik com o valor
    setFieldValue(fieldName, maskedValue);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validation}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue }) => (
        <Form
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem"
          }}
        >
          <Field
            as={TextField}
            fullWidth
            name="goodQuantity"
            type="text"
            variant="outlined"
            label={`Bom (${purchaseType})`}
            onChange={handleFieldChange("goodQuantity", setFieldValue)}
          />
          <ErrorMessage
            name="goodQuantity"
            component="div"
            style={{ color: "red" }}
          />
          <Field
            as={TextField}
            fullWidth
            name="diverseQuantity"
            type="text"
            variant="outlined"
            label={`Diverso (${purchaseType})`}
            onChange={handleFieldChange("diverseQuantity", setFieldValue)}
          />
          <ErrorMessage
            name="diverseQuantity"
            component="div"
            style={{ color: "red" }}
          />
          <Field
            as={TextField}
            fullWidth
            name="wasteQuantity"
            type="text"
            variant="outlined"
            label={`Ruim - Waste (${purchaseType})`}
            onChange={handleFieldChange("wasteQuantity", setFieldValue)}
          />
          <ErrorMessage
            name="wasteQuantity"
            component="div"
            style={{ color: "red" }}
          />
          <Field
            as={TextField}
            fullWidth
            name="wrongWeightQuantity"
            type="text"
            variant="outlined"
            label={`Peso divergente (${purchaseType})`}
            onChange={handleFieldChange("wrongWeightQuantity", setFieldValue)}
          />
          <ErrorMessage
            name="wrongWeightQuantity"
            component="div"
            style={{ color: "red" }}
          />

          <ButtonsContent>
            <Button
              type="submit"
              variant="contained"
              fullWidth
              isLoading={isLoading}
              disabled={Object.values(values).every(
                value => value == null || value === ""
              )}
            >
              Salvar
            </Button>
          </ButtonsContent>
        </Form>
      )}
    </Formik>
  );
};
